module.exports = __webpack_public_path__ + "img/04c339853e6240acadd4ee1021063278.dfa6d110.jpg";